
  import { applyLegalLang, legalLangFrom } from '/js/shared/legal-i18n.js';
  const DOC = document.documentElement.getAttribute('data-legal-doc') || 'privacy';
  // QUEUE ITEM BQ — two things were wrong here, and they cancelled out so neatly
  // that neither showed.
  //
  // This read `kaf_lang` / `lang`, and NOTHING in the product has ever written
  // either name — the portal's key was `kinetiqaf_lang`. So the rung the comment
  // described did not exist: a Spanish reader's saved preference never reached
  // this page, and the only reason it did not read as a bug is that the portal
  // ALSO appends `?lang=` when it links here (see the Settings rows in
  // app.html), and `?lang=` wins. The dead read was doing nothing at all.
  //
  // What it reads now is the PUBLIC pages' own key, which is what these pages
  // are: a stranger who chose Español on the intake and then opened the privacy
  // policy from its footer keeps reading Spanish. A signed-in client's language
  // still arrives on the URL, from their own profile, which is the only place
  // an account's language is allowed to come from.
  let stored = null;
  try { stored = localStorage.getItem('kinetiqaf_public_lang'); } catch (_) {
    // Storage blocked (private mode) — ?lang= and the browser still decide.
  }
  let lang = legalLangFrom(location.search, navigator.language, stored);
  // The switches always point at the OTHER language, and keep the hash so a
  // reader deep in §9 stays in §9 when they switch. Queue item KW (E-01): the
  // header's and the footer's both, named in their own language, and a press
  // repaints in place (applyLegalLang only swaps words) rather than reloading.
  function syncSwitches() {
    const other = lang === 'es' ? 'en' : 'es';
    document.querySelectorAll('[data-legal-lang-switch]').forEach((a) => {
      const to = a.getAttribute('data-legal-lang-switch') || other;
      a.setAttribute('href', '?lang=' + to + location.hash);
      a.setAttribute('hreflang', to);
      if (!a.getAttribute('data-legal-lang-switch')) a.setAttribute('lang', to);
    });
  }
  function paint() {
    applyLegalLang(document, lang, DOC);
    syncSwitches();
    paintRest();
  }
  document.querySelectorAll('[data-legal-lang-switch]').forEach((a) => a.addEventListener('click', (e) => {
    e.preventDefault();
    lang = a.getAttribute('data-legal-lang-switch') || (lang === 'es' ? 'en' : 'es');
    try { localStorage.setItem('kinetiqaf_public_lang', lang); } catch (_) { /* storage blocked: the URL still carries it */ }
    try {
      const url = new URL(location.href);
      url.searchParams.set('lang', lang);
      history.replaceState(history.state, '', url.toString());
    } catch (_) { /* an older browser: the repaint below still happens */ }
    paint();
  }));
  function paintRest() { /* nothing on this page depends on the language but its words */ }
  paint();
  window.addEventListener('hashchange', syncSwitches);
